module.exports = __webpack_public_path__ + "img/zq1.f1904365.png";